export const PERSON_KIND = {
  PF: 'p',
  PJ: 'e',
} as const;
